export enum ECursorMode {
    HAND = 'Hand',
    CURSOR = 'Cursor',
}
